<template>
	<ul id="mobility">
		<label class="label_radio">{{getLabel(params.label)}}  <span v-if="params.compulsory" class="star">*</span>:</label>
		<div class="template_input">
			<li v-for="(_value, key) in params.mobility">
				<input type="radio" v-bind:id="'mobility_'+key" v-bind:value="_value.value" name="Mobility" v-model="answer">
				<label v-bind:for="'mobility_'+key" v-on:touchstart="forceFocus" v-on:touchend="forceFocus">{{getLabel(_value.label)}}</label>
			</li>
			<li v-if="params.add_text" id="add_localization">
				<input type="text" v-bind:placeholder="getLabel(params.add_text)" v-model="input">
			</li>
		</div>
	</ul>
</template>
<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

export default {
	name: 'radio_mobility_input',
	data() {
		return {
			answer : "",
			input : "",
		}
	},
	props : ['params', 'oldValue', 'lang'],
	computed : {
	},
	methods : {
		validate : function(answer, input) {
			let param = this.params.mobility.find(e => e.value == answer);
			return answer && answer.length && param.showInput ? input && input.length : true;
		},
		notifyUpdate : function(answer, input) {
			if(!answer && !input) return this.$emit('validateField', this.params.name);
			let object = {answer, mobility_text : input};
			this.$emit('validateField', this.params.name, object);
		},
		getLabel : componentTools.getLabel,
		forceFocus : function(event){
			let label = event.target;
			if(!label || !label.htmlFor) return;
			let input = document.getElementById(label.htmlFor);
			if(!input || !input.click) return;
			input.click();
		}
	},
	watch: {
		answer : function(val){
			if(this.validate(val, this.input)) this.notifyUpdate(val, this.input);
			else this.notifyUpdate();
			var localization = document.getElementById("add_localization");
			let param = this.params.mobility.find(e => e.value == val);
			if(param.showInput) localization.classList.add("display");
			else localization.classList.remove("display");
			this.input = '';
		},
		oldValue : function(val){
			if(!val) {this.answer = ""; this.input = "";}
		},
		input : function(val) {
			if(this.validate(this.answer, val)) this.notifyUpdate(this.answer, val);
			else this.notifyUpdate()
		},
	},
	mounted : function(){
		if(typeof this.oldValue != "undefined"){
			this.answer = this.oldValue.answer || '';
			this.input = this.oldValue.mobility_text || '';
		}

	}
};
</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/radio_mobility_input.vue